export class UserAgentExchangePair {
  idUserAgentExchangePair: number;
  idUserAgent: number;
  idExchangePair: number;

  constructor(
    idUserAgentExchangePair: number,
    idUserAgent: number,
    idExchangePair: number,
  ) {
    this.idUserAgentExchangePair = idUserAgentExchangePair;
    this.idUserAgent = idUserAgent;
    this.idExchangePair = idExchangePair;
  }

  static fromRaw(raw: any): UserAgentExchangePair {
    return new UserAgentExchangePair(
      Number(raw.idUserAgentExchangePair),
      Number(raw.idUserAgent),
      Number(raw.idExchangePair),
    );
  }

  clone(): UserAgentExchangePair {
    return new UserAgentExchangePair(
      this.idUserAgentExchangePair,
      this.idUserAgent,
      this.idExchangePair,
    );
  }

  toPayload(): any {
    return {
      idUserAgentExchangePair: this.idUserAgentExchangePair,
      idUserAgent: this.idUserAgent,
      idExchangePair: this.idExchangePair,
    };
  }
}
